import React, { useState } from "react"
import "./index.scss"
import MailIcon from "../../images/mail_icon.png"
import Checkmark from "../../images/checkmark.png"
import addToMailchimp from "gatsby-plugin-mailchimp"

export const NewsletterForm = ({ placeholder, language }) => {
  const [email, setEmail] = useState("")
  const [resultMsg, setResultMsg] = useState("")
  const [errorMsg, setErrorMsg] = useState("")

  const handleSubmit = (e) => {
    setErrorMsg('')
    setResultMsg('')
    e.preventDefault()
    // console.log(email)
    addToMailchimp(email, {language}).then(data => {
      console.log(data)
      if (data.result === "error") {
        setErrorMsg(data.msg)
      } else {
        setResultMsg(data.msg)
      }
    })
      .catch(() => {
      })
  }

  return <div className="app-subscribe-form">
    <div className="app-newsletter-form">
      <form className="subscribe-form my-4 mx-auto" onSubmit={handleSubmit}>
        <input className="subscribe-input" type="email" placeholder={placeholder} onChange={(e) => setEmail(e.target.value)}/>
        <button type="submit" className="subscribe-submit" style={{pointerEvents: resultMsg? 'none': 'all'}}><img className="mail-icon" src={resultMsg ? Checkmark : MailIcon}/>
        </button>
      </form>
    </div>
    {!errorMsg && resultMsg &&
    <div className="subscribe-result pb-4" dangerouslySetInnerHTML={{ __html: resultMsg }}/>
    }
    {!resultMsg && errorMsg &&
    <div className="subscribe-error pb-4" dangerouslySetInnerHTML={{ __html: errorMsg }}/>
    }
  </div>
}
